import React from "react";
import QoldauMark from "../../../components/brand/QoldauMark";
import { BRAND } from "../landingConfig";

/**
 * The Qoldau lockup: icon tile + brand name.
 *
 * Extracted because it is rendered in three places (landing header, landing
 * footer, legal-page header) and was previously copy-pasted. It is deliberately
 * not a link — the callers wrap it in whatever <a>/<Link> their context needs.
 */
export default function Wordmark({ className = "" }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <QoldauMark className="h-8 w-auto shrink-0 text-brand" />
      <span className="text-2xl font-bold text-brand">{BRAND}</span>
    </span>
  );
}
